import React, { useMemo } from 'react';
import cx from 'clsx';
import { OrgVerifiedLogo } from '../OrgVerifiedLogo';
import { OfficialAccountVerifyStatus, useTheme } from 'hooks';
import imgDefaultOfficialAccount from 'assets/org/default-official-account.svg';
import imgDefaultOfficialAccountDark from 'assets/org/default-official-account-dark.svg';
import style from './index.module.scss';
import { UserCardPopupPropsPartial, UserCardPopup, UserAvatarProps } from '@/components';
export interface OfficialAccountAvatarProps {
  data?: OfficialAccount;
  size?: number;
  className?: string;
  onClick?(e: React.MouseEvent<HTMLDivElement>): void;
  logoVisible?: boolean;
  userCardPopup?: UserCardPopupPropsPartial;
  logoOption?: UserAvatarProps['officialLogoOption'];
  logoTooltipVisible?: boolean;
}

export const OfficialAccountAvatar = ({
  data,
  size = 100,
  className,
  onClick,
  logoOption = { size: 28 },
  logoVisible = true,
  userCardPopup,
  logoTooltipVisible = true,
}: OfficialAccountAvatarProps) => {
  const { isDark } = useTheme();
  const unverified = data?.verify_status !== OfficialAccountVerifyStatus.VERIFIED;
  const defaultAvatar = isDark ? imgDefaultOfficialAccountDark : imgDefaultOfficialAccount;

  const avatar =
    data?.verify_status === OfficialAccountVerifyStatus.INACTIVE
      ? defaultAvatar
      : data?.avatar_thumbnail_url || data?.avatar_url || defaultAvatar;

  const avatarSizeStyle = useMemo(() => ({ width: size, height: size }), [size]);

  const OfficialAvatar = (
    <div
      className={cx(style.officialAccountAvatar, onClick && style.cursor)}
      style={avatarSizeStyle}
      onClick={onClick}>
      <div className={style.avatar} style={avatarSizeStyle}>
        {!!avatar && (
          <img
            src={avatar}
            style={{ borderRadius: `${Math.round(size * 0.1)}px` }}
            className={style.avatarLogo}
            alt=""
          />
        )}
      </div>
    </div>
  );
  return (
    <div className={cx(style.container, className)}>
      {userCardPopup && data?.id ? (
        <div>
          <UserCardPopup {...(userCardPopup === true ? {} : userCardPopup)} address={data?.id}>
            {OfficialAvatar}
          </UserCardPopup>
        </div>
      ) : (
        OfficialAvatar
      )}
      {logoVisible ? (
        <OrgVerifiedLogo
          className={style.logo}
          disableTooltip={!logoTooltipVisible}
          size={logoOption.size}
          style={logoOption.customStyle}
          placement={logoOption.placement}
          align={logoOption.align}
          tooltipClassName={logoOption.tooltipClassName}
          unverified={unverified}
        />
      ) : null}
    </div>
  );
};
